import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, useMediaQuery } from '@mui/material';

import ModalContent from './ModalContent';

const SearchModal = ({ isOpen, onClose }) => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px - 960px

    const boxStyle = {
        borderRadius: 2,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '95%', sm: '90%', md: '85%' },
        maxWidth: 'lg',
        height: { xs: '95%', sm: '92%', md: '88%' },
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: { xs: 1, sm: 1.5, md: 2 },
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            sx={{
                overflow: 'auto',
                '& .MuiBackdrop-root': {
                    bgcolor: 'rgba(0, 0, 0, 0.6)', // Darker backdrop for focus
                },
            }}
        >
            <Box sx={boxStyle}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        pb: 0.5,
                    }}
                >
                    <IconButton
                        onClick={onClose}
                        size={isXs ? 'medium' : 'large'}
                        sx={{
                            color: 'text.primary',
                            '&:hover': { bgcolor: 'grey.100' }, // Smooth hover effect
                        }}
                    >
                        <CloseIcon fontSize={isXs ? 'medium' : 'large'} />
                    </IconButton>
                </Box>
                <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                    {isOpen ? <ModalContent /> : null}
                </Box>
            </Box>
        </Modal>
    );
};

export default SearchModal;